import {
  Component,
  OnInit,
  Input
} from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import {
  Router
} from '@angular/router';

import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { EventNotificationService } from '../../services/event_notification.service';
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';

@Component({
  selector: 'nestas-pidinfo',
  templateUrl: './pidinfo.component.html',
  styleUrls: ['./pidinfo.component.scss']
})
export class NestasPIDInfoComponent implements OnInit {

  @Input() steps;
  @Input() pid;
  @Input() module;


  show = [false, false, false];
  notifications = [];
  unseen = 0;
  isPhone = false;

  constructor(private _user: UserService, private _router: Router, public translate: TranslateService, private _auth: AuthService,
    private _notificationService: EventNotificationService, private _sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
  }

  me() {
    return this._user.me();
  }

  isAdmin() {
    return this._user.isAdmin();
  }

  goToAudittrail(){
    this._router.navigate(['audittrail', 'pid', this.pid._id]);
  }

  isLoggedIn() {
    return this._user.isLoggedIn();
  }

  goToStep(ref) {
    this._router.navigate(ref);
  }

  addSubPID(){
    this.module.modal.newPID = true;
  }

  getStepMaxWidth(isLast) {
    let width = ((this.steps.length == 0) ? 100 : (100 / this.steps.length)) + '%';

    return this._sanitizer.bypassSecurityTrustStyle(width);
  }
}
  